import { AssignmentItem } from 'shared/types/entities';

export const filteredContentItems = (arr: AssignmentItem[] | null, isContent?: boolean) => {
  if (isContent) {
    return arr?.filter((el) => el.type?.name === 'video' || el.type?.name === 'reading');
  }
  return arr?.filter((el) => el.type?.name !== 'video' && el.type?.name !== 'reading');
};
